<template>
  <b-card border-variant="dark" class="rounded-custom-1 border-custom-2">
    <b-row v-if="currentStep!==-1" class="justify-content-center">
      <b-col cols="8">
        <keep-alive>
          <component
            :is="steps[currentStep].component"
            :verify-key="verifyKey"
            :submitting="submitting"
            @back="back(currentStep)"
            @skip="next(currentStep)"
            @submitted="next(currentStep)"
          />
        </keep-alive>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { mapGetters } from 'vuex'
import Identity from '@/views/signup/user/Identity'
import AboutYou from '@/views/signup/user/AboutYou'
import Contact from '@/views/signup/user/Contact'
import { toFormData } from '@/helpers/helpers'
import { SIGNUP_STEP_TYPE } from '@/helpers/types'

export default {
  name: 'CreateUser',

  props: {
    verifyKey: {
      type: String
    },

    from: {
      type: String
    }
  },

  computed: {
    ...mapGetters('signup', [
      'aboutyou',
      'contact'
    ])
  },

  data() {
    return {
      steps: [
        { type: SIGNUP_STEP_TYPE.IDENTITY, label: 'Identity', component: Identity },
        { type: SIGNUP_STEP_TYPE.ABOUTYOU, label: 'About you', component: AboutYou },
        { type: SIGNUP_STEP_TYPE.CONTACT, label: 'Contact', component: Contact }
      ],
      submitting: false,
      currentStep: -1
    }
  },

  async mounted() {
    if (this.from === 'google') {
      const token = await this.$store.dispatch('getToken')
      if (token) {
        await this.$store.dispatch('signup/fetchProfileSignUp')
        this.currentStep = 1
      } else {
        this.toError()
      }
    } else {
      if (!this.verifyKey) {
        this.toError()
      } else {
        try {
          await this.$store.dispatch('teamInvitationVerify', this.verifyKey)
          this.currentStep = 0
        } catch {
          this.toError()
        }
      }
    }
  },

  methods: {
    toError() {
      // TODO: Need to redirect to error/expiration page with connect to button?
      this.$router.replace({ name: 'ConnectToWorkspace' })
    },

    async onComplete() {
      const profileData = { ...this.aboutyou, ...this.contact }

      this.submitting = true
      try {
        // Update user profile
        if (Object.keys(profileData).length > 0) {
          await this.$store.dispatch('updateProfileMe', toFormData(profileData))
        }

        this.$router.push({ name: 'Home' })
      } catch {
        this.$bvToast.toast('Unexpected error', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.submitting = false
      }
    },

    async next(from) {
      const next = from + 1
      if (next === this.steps.length) {
        await this.onComplete()
      } else {
        this.currentStep = next
      }
    },

    back(from) {
      if (from > 0) {
        this.currentStep = from - 1
      }
    }
  },

  components: {
    Identity,
    AboutYou,
    Contact
  }
}
</script>
